// src/components/ProductGrid/ProductGrid.jsx

import React from 'react';
import { Link } from 'react-router-dom';
import './ProductGrid.css';
// YENİ: Marka isimlerini almak için staticBrands'ı import et
import { brands as staticBrands } from '../data/productData'; // Yolunu kontrol et

function ProductGrid({ products, loading }) {

  // YENİ: Marka ID'sinden ismi bulan helper
  const getBrandName = (brandId) => {
    return staticBrands.find(b => b.id === brandId)?.name || brandId;
  };

  // Yükleniyor durumu
  if (loading) {
    return (
      <div className="product-grid loading">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="product-card is-loading">
            <div className="product-card-image-wrapper">
              <div className="placeholder-img"></div>
            </div>
            <div className="product-card-info">
              {/* YENİ: Marka placeholder */}
              <p className="product-card-brand placeholder-text"></p>
              <h3 className="product-card-name placeholder-text"></h3>
              <p className="product-card-price placeholder-text"></p>
              {/* Not: Kategori placeholder'ı artık marka ile birleşti */}
            </div>
          </div>
        ))}
      </div>
    );
  }

  // Ürün yoksa
  if (products.length === 0) {
    return <div className="no-products-found">Bu filtrelere uygun ürün bulunamadı.</div>;
  }

  // Ürünler varsa
  return (
    <div className="product-grid">
      {products.map((product) => (
        <div key={product.id} className="product-card">
          <Link to={`/urunler/${product.id}`} className="product-card-link">

            <div className="product-card-image-wrapper">
              <img
                src={product.imageUrl || 'https://via.placeholder.com/300?text=Resim+Yok'}
                alt={product.name}
                className="product-card-img"
                onError={(e) => { e.target.onerror = null; e.target.src="https://via.placeholder.com/300?text=Resim+Yok" }}
              />
              {/* İsteğe Bağlı: İndirim etiketi vb. buraya eklenebilir */}
              {/* <span className="product-badge">Yeni</span> */}
            </div>
            <div className="product-card-info">
              {/* YENİ: Markayı göster */}
              <p className="product-card-brand">
                {getBrandName(product.brandId)}
              </p>
              <h3 className="product-card-name">{product.name}</h3>
              {/* Kategori artık burada gösterilmiyor, istersen eklenebilir */}
              {/* <p className="product-card-category">{product.mainCategoryName}</p> */}
              <p className="product-card-price">
                {product.price ? product.price.toFixed(2) : '0.00'} TL
              </p>
            </div>
          </Link>
        </div>
      ))}
    </div>
  );
}

export default ProductGrid;